const neutral = {
    0: 'rgb(255, 255, 255)',
    50: 'rgb(244, 244, 246)',
    100: 'rgb(232, 233, 237)',
    150: 'rgb(221, 223, 228)',
    200: 'rgb(209, 212, 219)',
    250: 'rgb(198, 201, 210)',
    300: 'rgb(186, 190, 201)',
    350: 'rgb(175, 179, 192)',
    400: 'rgb(164, 169, 183)',
    450: 'rgb(152, 158, 174)',
    500: 'rgb(141, 147, 165)',
    550: 'rgb(129, 136, 156)',
    600: 'rgb(118, 125, 147)',
    650: 'rgb(108, 115, 137)',
    700: 'rgb(99, 105, 126)',
    750: 'rgb(90, 96, 114)',
    800: 'rgb(81, 86, 103)',
    850: 'rgb(72, 77, 91)',
    900: 'rgb(63, 67, 80)',
    950: 'rgb(54, 58, 69)',
    1000: 'rgb(45, 48, 57)',
    1050: 'rgb(36, 38, 46)',
    1100: 'rgb(27, 29, 34)',
    1150: 'rgb(18, 19, 23)',
    1200: 'rgb(9, 10, 11)',
    1250: 'rgb(0, 0, 0)',
};
export default neutral;
